<div class="fixed inset-0 z-[100] bg-base-300/95 backdrop-blur flex items-center justify-center p-4">
  <div class="card paper-card w-full max-w-md">
    <div class="card-body">
      <h2 class="card-title h2 mb-1 flex items-center gap-2">
        <span class="dice-chip"><span class="dice-pip"></span></span>
        Anmeldung
      </h2>
      <p class="opacity-80 mb-4">
        Du greifst von außerhalb des Heimnetzes auf KnuffelBoard zu. Bitte melde dich an.
      </p>

      @if (noUsers()) {
        <div class="alert alert-warning mb-4">
          <span>
            Es ist noch kein Benutzer angelegt. Der erste Benutzer muss einmalig im
            Heimnetz über das Zahnradsymbol erstellt werden.
          </span>
        </div>
      }

      <form (ngSubmit)="submit()">
        <div class="form-control">
          <label class="label"><span class="label-text">Benutzername</span></label>
          <input
            [(ngModel)]="username"
            name="username"
            autocomplete="username"
            class="input input-bordered input-lg"
            placeholder="Benutzername"
            [disabled]="busy()" />
        </div>

        <div class="form-control mt-3">
          <label class="label"><span class="label-text">Kennwort</span></label>
          <input
            [(ngModel)]="password"
            name="password"
            type="password"
            autocomplete="current-password"
            class="input input-bordered input-lg"
            placeholder="Kennwort"
            [disabled]="busy()" />
        </div>

        <label class="label cursor-pointer justify-start gap-3 mt-3">
          <input
            type="checkbox"
            [(ngModel)]="rememberMe"
            name="rememberMe"
            class="checkbox checkbox-primary"
            [disabled]="busy()" />
          <span class="label-text">Angemeldet bleiben (30 Tage)</span>
        </label>

        @if (error()) {
          <div class="alert alert-error mt-3">
            <span>{{ error() }}</span>
          </div>
        }

        <button
          type="submit"
          class="btn btn-primary btn-lg w-full mt-5"
          [disabled]="busy()">
          @if (busy()) {
            <span class="loading loading-spinner"></span>
          }
          {{ busy() ? 'Anmelden…' : 'Anmelden' }}
        </button>
      </form>
    </div>
  </div>
</div>
